import React from "react";
import s from "./HeaderMobileCabinet.module.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { userTypes } from "../../types/userTypes";
import NavBarSvgSelector from "../NavBar/NavBarSvgSelector";

const HeaderMobileCabinet = () => {
	const navigate = useNavigate();
	const userView: userTypes = useSelector((state: any) => state.userData.user);
	return (
		<div className={`${s.mobileCabinetHeaderContainer} mui-fixed`}>
			{/* <Link to={"/personal_cabinet/settings"}> */}
			<div className={s.leftSide}>
				<div className={s.arrow}>
					<span onClick={() => navigate(-1)}>
						<svg
							width="8"
							height="17"
							viewBox="0 0 10 19"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M8.69531 1L0.741612 9.52667L8.78782 17.9997"
								stroke="white"
							/>
						</svg>
					</span>
				</div>
			</div>
			<Link to={"/personal_cabinet/settings"} className={s.rightSide}>
				<div className={s.avatarAndInfoBlock}>
					<div className={s.avatar}>
						{userView.photo?.photoUrl ? (
							<img src={userView.photo?.photoUrl} alt="avatar" />
						) : (
							<NavBarSvgSelector id="profile" />
						)}
					</div>
					<div className={s.info}>
						<div className={s.infoName}>
							{userView?.last_name || ""} {userView?.name || ""}
						</div>
						<div className={s.infoPhone}>{userView?.phone || ""}</div>
					</div>
				</div>
				<div className={s.settings}>
					<svg
						width="23"
						height="23"
						viewBox="0 0 23 23"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M19.918 8.81313L20.0292 9.16094H20.3943H20.8826C21.774 9.16094 22.5 9.88694 22.5 10.7782V12.2217C22.5 13.113 21.774 13.839 20.8827 13.839H20.3944H20.0292L19.9181 14.1868C19.768 14.6565 19.5787 15.1127 19.3518 15.551L19.1837 15.8758L19.4423 16.1344L19.7884 16.4805L19.7886 16.4806C20.4281 17.1195 20.4119 18.145 19.7883 18.7679L19.7881 18.7681L18.7678 19.7883L18.7676 19.7886C18.1438 20.4132 17.1183 20.4269 16.4805 19.7883L16.4803 19.7881L16.1345 19.4423L15.8759 19.1837L15.5511 19.3518C15.1128 19.5787 14.6565 19.768 14.1869 19.9181L13.8391 20.0292V20.3944V20.8827C13.8391 21.774 13.1131 22.5 12.2217 22.5H10.7783C9.88692 22.5 9.16092 21.774 9.16092 20.8827V20.3944V20.0292L8.81313 19.9181C8.34353 19.768 7.88724 19.5786 7.44884 19.3518L7.12407 19.1837L6.86551 19.4423L6.51943 19.7884L6.51923 19.7886C5.8804 20.4282 4.85481 20.4119 4.23207 19.7883L4.23182 19.7881L3.21161 18.7679L3.21143 18.7677C2.58778 18.1447 2.57215 17.1193 3.21169 16.4805L3.21188 16.4803L3.55769 16.1345L3.81627 15.8759L3.6482 15.5511C3.42134 15.1128 3.23199 14.6565 3.08192 14.1869L2.97078 13.8391H2.60564H2.11734C1.226 13.8391 0.5 13.1131 0.5 12.2218V10.7782C0.5 9.88692 1.226 9.16095 2.11732 9.16098H2.11734H2.60564H2.97079L3.08192 8.81316C3.23199 8.34348 3.42134 7.8873 3.6482 7.44893L3.81627 7.12415L3.55769 6.86557L3.21161 6.51949L3.21142 6.5193C2.57186 5.88043 2.58811 4.85497 3.21169 4.23208L3.21187 4.2319L4.23218 3.21168L4.23244 3.21141C4.85613 2.58683 5.88167 2.57309 6.51954 3.21172L6.51975 3.21193L6.86551 3.5577L7.12409 3.81628L7.44887 3.6482C7.88725 3.42134 8.34352 3.23195 8.81309 3.08193L9.16092 2.9708V2.60565V2.1173C9.16092 1.22597 9.88689 0.5 10.7782 0.5H12.2217C13.1131 0.5 13.839 1.22598 13.839 2.1173V2.60565V2.97077L14.1868 3.08192C14.6564 3.23199 15.1127 3.42139 15.5511 3.64822L15.8759 3.81626L16.1344 3.5577L16.4805 3.21162L16.4807 3.21141C17.1196 2.57183 18.1451 2.58812 18.7679 3.2117L18.7681 3.21194L19.7884 4.23212L19.7885 4.23229C20.4122 4.85529 20.4278 5.88067 19.7883 6.51953L19.7881 6.51972L19.4423 6.86553L19.1837 7.12411L19.3518 7.44888C19.5786 7.88725 19.768 8.34348 19.918 8.81313ZM5.99569 11.5C5.99569 14.5355 8.46442 17.0043 11.5 17.0043C14.5355 17.0043 17.0043 14.5355 17.0043 11.5C17.0043 8.46449 14.5355 5.9957 11.5 5.9957C8.46442 5.9957 5.99569 8.46449 5.99569 11.5Z"
							stroke="#F1F1F1"
						/>
					</svg>
				</div>
			</Link>
			{/* </Link> */}
		</div>
	);
};

export default HeaderMobileCabinet;
